import { axiosInstance } from "../../../axios/axiosInstance";

const API_PAYROLL_URL = "admin/payroll";
const API_PAYROLL_MODULE_LIST_URL = API_PAYROLL_URL + "/list";
const API_RUN_PAYROLL_URL = API_PAYROLL_URL + "/run";
const API_RUN_MANUAL_PAYROLL_URL = API_PAYROLL_URL + "/manual-run";

export const getPayroll = (dataToBeSent) => {
  return axiosInstance.get(
    `${API_PAYROLL_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${
      dataToBeSent?.limit || ""
    }&search=${dataToBeSent?.search || ""}`
  );
};

export const runPayroll = (dataToBeSent) => {
  return axiosInstance.post(
    `${API_RUN_PAYROLL_URL}/${dataToBeSent?.selectedPayrollId}`
  );
};

export const runManualPayroll = (dataToBeSent) => {
  return axiosInstance.post(
    `${API_RUN_MANUAL_PAYROLL_URL}/${dataToBeSent?.selectedPayrollId}`
  );
};
